import type { SVGProps } from 'react'
const SvgSySearchAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd" clipRule="evenodd">
			<path d="M11 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12M9.852 8.228A3 3 0 0 1 11 8a.5.5 0 0 0 0-1 4 4 0 0 0-4 4 .5.5 0 0 0 1 0 3 3 0 0 1 1.852-2.772" />
			<path
				fillOpacity={0.24}
				d="M17.928 15a.5.5 0 0 0-.866-.5 7 7 0 0 1-2.562 2.562.5.5 0 1 0 .5.866A8 8 0 0 0 16.292 17l2.854 2.855a.5.5 0 1 0 .707-.708L17 16.292q.527-.597.93-1.292"
			/>
		</g>
	</svg>
)
export default SvgSySearchAlt
